// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Selectable_checkbox__z8x8h","disableEvent":"Selectable_disableEvent__jXf4f"};